import React from 'react';

const AllCustomer = () => {
    return (
        <div>
            
        </div>
    );
};

export default AllCustomer;